import CCSectionsPermissionsTable from "./CCSectionsPermissionsTable";
import AddCCSectionPermissionDialog from "./add-section/AddCCSectionPermissionDialog";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../../../../../../shared/components/accordion/Accordion";
import { Button } from "../../../../../../../../shared/components/button/Button";

const CCSectionsPermissionsPanel = ({
  data,
  sections,
  onCreationHandler,
  onDeletionHandler,
  onRoleDeletionHandler,
}) => {
  return (
    <>
      <Accordion type="single" collapsible>
        {data &&
          data.map((item, index) => {
            const filteredSections = sections?.filter((x) =>
              item.value.includes(x.id),
            );
            const availableSections = sections?.filter(
              (x) => !item.value.includes(x.id),
            );
            return (
              <AccordionItem key={`acc_item_${index}`} value={item.role.code}>
                <AccordionTrigger>
                  {item.role.name} - ({item.value.length} elementos)
                </AccordionTrigger>
                <AccordionContent>
                  <div className="flex flex-row-reverse">
                    <Button
                      variant="destructive"
                      className="h-7 gap-1"
                      onClick={() => onRoleDeletionHandler(item.id)}
                    >
                      Borrar
                    </Button>
                    <AddCCSectionPermissionDialog
                      onSubmitHandler={(formValues) =>
                        onCreationHandler(item, formValues)
                      }
                      sections={availableSections.map((x) => {
                        return { label: x.name, value: x.id };
                      })}
                    />
                  </div>
                  <CCSectionsPermissionsTable
                    data={filteredSections}
                    onDeletion={(sectionId) =>
                      onDeletionHandler(sectionId, item)
                    }
                  />
                </AccordionContent>
              </AccordionItem>
            );
          })}
      </Accordion>
    </>
  );
};

export default CCSectionsPermissionsPanel;
